import { Icon } from '@iconify/react';
import windowsFilled from '@iconify/icons-ant-design/exception-outlined';
import { useState, useEffect } from 'react';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import { fShortenNumber } from '../../../utils/formatNumber';
import { baseUrl } from '../../../utils/constants';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.warning.darker,
  backgroundColor: theme.palette.warning.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
    theme.palette.warning.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 0;

export default function AppItemOrders() {
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [dashSum, setDashSum] = useState({
    totalActive: 0,
    newMembers: 0,
    paymentsThisMonth: 0.0,
    failedDebitOrders: 0.0
  });

  useEffect(() => {
    getDashBoardSummaries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDashBoardSummaries = () => {
    fetch(`${baseUrl}/api/client/getDashBoardSummaries`)
      .then((res) => res.json())
      .then(
        (result) => {
          setDashSum(result.result);
        },
        (error) => {
          notifyPopup(`Error in getDashBoardSummaries!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={windowsFilled} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{fShortenNumber(dashSum.paymentsThisMonth)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Pending Claims
      </Typography>
    </RootStyle>
  );
}
